import { create } from 'zustand'
import * as authApi from '@/api/auth'
import type { User } from '@/api/types'

/**
 * AuthStore is the reference example for global state in this project.
 *
 * Pattern to follow for every store:
 *   - keep the state shape and the actions that mutate it together,
 *   - actions call into `src/api` and store the result; they hold no
 *     transport logic themselves,
 *   - components read state with a selector: `useAuthStore((s) => s.user)`.
 *
 * Copy this file as the starting point for new stores.
 */
type AuthState = {
  user: User | null

  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  /** Restore an existing session on startup. Resolves whether or not one exists. */
  restoreSession: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,

  login: async (email, password) => {
    const user = await authApi.login(email, password)
    set({ user })
  },

  logout: async () => {
    try {
      await authApi.logout()
    } catch (e) {
      console.warn('Logout anrop misslyckades', e)
    } finally {
      set({ user: null })
    }
  },

  restoreSession: async () => {
    try {
      const user = await authApi.fetchCurrentUser()
      set({ user })
    } catch {
      // No valid session — stay logged out.
      set({ user: null })
    }
  }
}))
